<template>
  <div class="reimburseManage">
    <OATable
      ref="reimburseManage"
      :data="data"
      :columns="columns"
      :filterData="filterData"
      @search="handleSearch"
      :loading="loading"
      @cellClick="cellClick"
    ></OATable>
  </div>
</template>
<script>
import { resFilter } from "@/common/util.js";
import { jump } from "@/common/jump";
import OAJump from "@/components/OAJump/OAJump";
import { confirmStyle } from "@/common/dictionary";
import reimburseApi from "@/services/reimburse.js";

export default {
  name: "reimburseManage",
  components: {
    OAJump,
  },
  data() {
    let that = this;
    return {
      filterData: {
        spnum: {
          formType: "a-input",
          value: undefined,
          col: 4,
          placeholder: "审批单号",
        },
        spStatus: {
          formType: "a-select",
          value: undefined,
          placeholder: "审批状态",
          api: "getApprovalStatus",
          col: 4,
          format: function (data) {
            let res = data.filter((item) => {
              return item.code == 2 || item.code == 12;
            });
            return res;
          },
        },
        applyTime: {
          formType: "a-date-picker",
          type: "daterange",
          value: undefined,
          startPlaceholder: "申请开始时间",
          endPlaceholder: "申请结束时间",
          col: 6,
        },
      },
      columns: [
        {
          title: "审批单号",
          component: {
            name: OAJump,
            props: {
              textKey: "spNum",
              url: "reimburseDetail",
              paramKey: "id",
              query: {
                type: 0,
              },
            },
          },
        },
        {
          title: "审批人",
          key: "approvalName",
        },
        {
          title: "审批状态",
          key: "spStatusName",
        },
        {
          title: "申请时间",
          key: "applyTime",
        },
        {
          title: "操作",
          key: "spStatus",
          width: 110,
          formatter: function (row, column, cellValue, index) {
            return cellValue == 2 ? "确认付款" : "已报销";
          },
          className: "handle",
          labelClassName: "normal",
        },
      ],
      data: [],
      loading: false,
    };
  },
  mounted() {},
  methods: {
    async handleSearch(val) {
      val["type"] = 3;
      this.loading = true;
      this.param = val;
      let res = await reimburseApi.getApproval(val);
      this.data = res.data.data;
      this.loading = false;
    },
    cellClick(val) {
      if (
        val.cell.className == "el-table_1_column_5  handle" &&
        val.row.spStatus == 2
      ) {
        this.$confirm("是否确认付款", "提示", confirmStyle)
          .then(async () => {
            let res = await reimburseApi.confirmPayment({
              id: val.row.id,
            });
            resFilter(res, this.handleSearch(this.param));
          })
          .catch(() => {});
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/reimburse/reimburseManage.vue